import React, { useState } from 'react';
import { List } from 'antd';
import moment from 'moment';
import { Session, GroupedSessionsProject, NodeCategory, Metadata } from 'api/useChat';
import MoreActions from '../MoreActions/MoreActions';
import { Mode } from '../state/chatState';

interface SessionListProps {
  mode: Mode;
  sessions: [string, Session[]][];
  currentSessionId: {
    id: string;
    metadata: Metadata;
    updatedAt: string;
    index: number;
    category: string;
    project: GroupedSessionsProject | null;
  } | null;
  projectIndex: number;
  category: string;
  project: GroupedSessionsProject;
  searchValue: string;
  onSessionSelect: (
    session: Session,
    index: number,
    category: string,
    project: GroupedSessionsProject
  ) => Promise<void>;
}

const SessionList: React.FC<SessionListProps> = ({
  mode,
  sessions,
  currentSessionId,
  projectIndex,
  category,
  project,
  searchValue,
  onSessionSelect
}) => {
  const [hoveredSessionId, setHoveredSessionId] = useState<string | null>(null);

  return (
    <List
      split={false}
      dataSource={sessions}
      renderItem={([date, sessions]: [string, Session[]]) => (
        <div key={date} className="mb-3 ml-3">
          <h4 className="font-bold text-gray-900">
            {moment(date, 'YYYY-MM-DD').isSame(moment(), 'day')
              ? 'Today'
              : moment(date, 'YYYY-MM-DD').isSame(moment().subtract(1, 'day'), 'day')
              ? 'Yesterday'
              : moment(date, 'YYYY-MM-DD')
                  .format('MMMM D, YYYY')
                  .replace(/^[a-z]/, (c) => c.toUpperCase())}
          </h4>
          {sessions.map((session, index) => (
            <List.Item
              key={session.id}
              className={`p-2 session-border rounded-lg rounded-l-none ml-2 text-gray-800 cursor-pointer ${
                mode === 'embedded' ? 'hover:bg-gray-100' : 'hover:bg-white'
              } hover:text-black transition-colors ${
                currentSessionId?.id === session.id ? (mode === 'embedded' ? 'bg-gray-100' : 'bg-white') : ''
              }`}
              onClick={() => onSessionSelect(session, index, category, project)}
              onMouseEnter={() => setHoveredSessionId(session.id)}
              onMouseLeave={() => setHoveredSessionId(null)}
              extra={
                searchValue?.length <= 0 &&
                hoveredSessionId === session.id && (
                  <MoreActions
                    page="side-navigation"
                    session={session}
                    sessionIndex={index}
                    projectIndex={projectIndex}
                    category={category}
                    nodeCategory={NodeCategory.SESSION}
                  />
                )
              }
            >
              <List.Item.Meta
                description={
                  <div
                    className="truncate text-[#5f5a5af0] p-0"
                    title={session.title.length > 30 ? session.title : undefined}
                  >
                    {session.title}
                  </div>
                }
              />
            </List.Item>
          ))}
        </div>
      )}
    />
  );
};

export default SessionList;
